import { Provider } from 'react-redux';
import requester from '@zg-rentals/particles-js-requester';
import { setupGrowthClient } from '@zg-rentals/rental-growth-api';

// components
import PriceMyRental from './PriceMyRental';

// flux
import store from './flux/configureStore';

// constants
import StringConstants from './constants/StringConstants';

// types
import type { AxiosInstance } from 'axios';
import type { PriceMyRentalPropsType } from './PriceMyRental';
import type { ErrorLoggerType, FormatForLogType } from './utils/errors/types';

type PMRWidgetPropsType = PriceMyRentalPropsType & {
  appLogger?: ErrorLoggerType;
  requestClient?: AxiosInstance;
};

if (typeof window !== 'undefined') {
  setupGrowthClient(`${window.location.origin}/${StringConstants.RG_PROXY_PATH.replace(/\/$/, '')}`);
}

let requestClient = requester({ api: typeof window === 'undefined' ? undefined : '' });

let logger: ErrorLoggerType = {
  error: (formattedError: FormatForLogType, message: string) => console.error(formattedError, message), // eslint-disable-line no-console
};

const PMRWidget = (props: PMRWidgetPropsType) => {
  const { appLogger } = props;

  if (appLogger) {
    logger = appLogger;
  }

  if (props.requestClient) {
    requestClient = props.requestClient;
  }

  return (
    <Provider store={store}>
      <PriceMyRental {...props} />
    </Provider>
  );
};

export { logger };
export { requestClient };
export default PMRWidget;
